<template>
  <a
    :href="link"
    class="btn btn-primary text-nowrap text-decoration-none"
    target="_blank"
    rel="noopener"
    @click.stop
  >
    <span
      v-if="!price"
      data-bs-toggle="tooltip"
      class="d-contents"
      title="Wir können für diese Verbindung leider keinen Preis ermitteln. Vielleicht kann die Bahn den Preis angeben"
      >Tickets
    </span>
    <span v-else class="d-contents">{{ price.amount.toFixed(2) }}€ </span>
    <i class="icon icon-box-arrow-up-right"></i>
  </a>
</template>

<script setup lang="ts">
import { Dayjs } from 'dayjs'
import { type Price } from '~/types/fptfTypes'

const props = defineProps<{
  start: string
  destination: string
  datetime: Dayjs
  price?: Price
  refreshToken: string
}>()

const link = `https://www.bahn.de/buchung/start#sts=true&so=${encodeURIComponent(
  props.start
)}&zo=${encodeURIComponent(props.destination)}&soid=O=${encodeURIComponent(
  props.start
)}&zoid=O=${encodeURIComponent(props.destination)}&cbs=true&hd=${props.datetime.toISOString()}&gh=${
  props.refreshToken
}`
</script>
